export enum DataLayerEvents {
  ChatBotOpened = 'chatbotOpened',
  ChatBotInteracted = 'chatbotInteracted',
  ChatBotFeedbackUseCasePositive = 'chatbotFeedbackUsecasePositive',
  ChatBotFeedbackUseCaseNegative = 'chatbotFeedbackUsecaseNegative',
}

const dataLayerPushEvent = (event: string) => {
  if (window?.dataLayer) {
    const { dataLayer } = window

    dataLayer.push({ event })
  }
}

export default dataLayerPushEvent
